import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5457_9796)">
      <path
        d="M12.25 0.758057C5.62704 0.758057 0.25 6.1351 0.25 12.758C0.25 19.381 5.62704 24.758 12.25 24.758C18.8729 24.758 24.25 19.381 24.25 12.758C24.2664 6.1351 18.8893 0.758057 12.25 0.758057ZM17.5287 14.2826H14.1352V15.5613C14.1352 18.1351 12.0533 20.217 9.47949 20.217C6.90573 20.217 4.82376 18.1351 4.82376 15.5613C4.82376 12.9875 6.90573 10.9056 9.47949 10.9056H10.7418V14.299H14.1352V10.8892H17.5287V14.2826ZM19.2172 9.18427H15.3975C14.6926 9.18427 14.1352 9.75804 14.1188 10.463V10.8892H10.7418V10.463C10.7418 7.88919 12.8238 5.80723 15.3975 5.80723H19.2172V9.18427Z"
        fill="#11181C"
      />
      <path
        d="M9.46301 14.2827C8.7581 14.2827 8.18433 14.8565 8.18433 15.5614C8.18433 16.2663 8.7581 16.8401 9.46301 16.8401C10.1679 16.8401 10.7417 16.2663 10.7417 15.5614V14.2827H9.46301C9.46301 14.2663 9.46301 14.2663 9.46301 14.2827Z"
        fill="#151718"
      />
      <path
        d="M17.2787 10.8892H13.8853V14.2826H17.2787V10.8892Z"
        fill="white"
      />
      <path
        d="M10.4918 15.5449C10.4918 16.2498 9.91799 16.8236 9.21308 16.8236C8.50816 16.8236 7.93439 16.2498 7.93439 15.5449C7.93439 14.84 8.50816 14.2662 9.21308 14.2662H10.4918V10.8892H9.22947C6.6557 10.8892 4.57373 12.9711 4.57373 15.5449C4.57373 18.1187 6.6557 20.2006 9.22947 20.2006C11.8032 20.2006 13.8852 18.1187 13.8852 15.5449V14.2662H10.4918V15.5449Z"
        fill="white"
      />
      <path
        d="M15.1474 9.1843H18.9671V5.80725H15.1474C12.5737 5.80725 10.4917 7.88922 10.4917 10.463V10.8892H13.8851V10.463C13.8851 9.75807 14.4589 9.1843 15.1474 9.1843Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5457_9796">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.25 0.758057)"
        />
      </clipPath>
    </defs>
  </svg>
)
